<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Between Two Thorns (BOOK 1)">Between Two Thorns</h1>
<h3 class="sigil_not_in_toc"><i>The Split Worlds: Book One</i></h3>
<h3 class="sigil_not_in_toc">Emma Newman</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 1_BTT_TITLEPAGE.vue?0eab64b4